import React, { useState } from "react";
import "./Brand.css";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { useEffect } from "react";

const BrandPrinterSetup = ({ brand, image }) => {
  const [model, setModel] = useState("");
const his=useHistory()
useEffect(() => {
        // 👇️ scroll to top on page load
        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
      }, []);

  const handleSubmit = (e) => {
    
    e.preventDefault();
    if (!model.trim()) {
      alert(`Please enter your ${brand} printer model.`);
      return;
    }
    else{
his.push(`/${brand.toLowerCase()}/driver-download`);
    }
  };

  return (
    <div className={`brand_container brand_${brand.toLowerCase()}`}>
      <div className="brand_wrapper">
        {/* Left: Form */}
        <div className="brand_left">
          <h2 className="brand_title">Setup Your {brand} Printer</h2>
          <p className="brand_subtitle">
            Search Your {brand} Product or Printer Model <br />
            Find a compatible printer driver for setup and installation
          </p>

          <form className="brand_form" onSubmit={handleSubmit}>
            <label className="brand_label" htmlFor={`${brand}-model`}>
              Enter Your Printer Model <span className="brand_required">*</span>
            </label>
            <input
              id={`${brand}-model`}
              type="text"
              placeholder={`Example: ${brand} XYZ 1234`}
              className="brand_input"
              value={model}
              onChange={(e) => setModel(e.target.value)}
            />
            <button type="submit" className="brand_btn">
              NEXT
            </button>
          </form>
        </div>

        {/* Right: Image */}
        <div className="brand_right">
          <img src={image} alt={`${brand} Printer`} className="brand_img" />
        </div>
      </div>

      <div className="brand_footer">
        <h3 className="brand_footerTitle">QUICK SEARCH: LATEST PRINTER DRIVERS</h3>
        <p className="brand_footerText">
          Search the latest compatible printer driver for optimal performance.
        </p>
      </div>
    </div>
  );
};

export default BrandPrinterSetup;
